import { useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { Pause, Timer } from 'lucide-react';
import { formatMinutes } from '@kaba/shared';
import { navigate } from '../lib/router';
import { stopTimer, useRunningTimer } from './card/TimeSection';

/** Laufender Timer auf jeder Seite sichtbar und mit einem Tipp zu stoppen */
export function TimerBar() {
  const { data: running } = useRunningTimer();
  const qc = useQueryClient();
  const [, tick] = useState(0);
  useEffect(() => {
    if (!running) return;
    const t = setInterval(() => tick((x) => x + 1), 30_000);
    return () => clearInterval(t);
  }, [running]);
  if (!running) return null;
  const min = Math.floor((Date.now() - new Date(running.startedAt).getTime()) / 60_000);
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-[max(5.5rem,calc(env(safe-area-inset-bottom)+5rem))] z-30 flex justify-center px-4 sm:bottom-5">
      <div className="pointer-events-auto flex max-w-md items-center gap-2 rounded-full bg-emerald-700 py-1 pr-1 pl-3 text-sm text-white shadow-xl">
        <Timer size={16} className="shrink-0 animate-pulse" />
        <button
          className="min-w-0 truncate text-left"
          onClick={() => navigate(`/b/${running.boardId}?card=${running.cardId}`)}
          title="Karte öffnen"
        >
          <span className="font-semibold tabular-nums">{formatMinutes(min)}</span> · {running.cardTitle}
        </button>
        <button
          aria-label="Timer stoppen"
          onClick={async () => {
            await stopTimer(qc);
            void qc.invalidateQueries({ queryKey: ['time', running.cardId] });
          }}
          className="inline-flex min-h-9 shrink-0 items-center gap-1 rounded-full bg-white/20 px-3 font-medium hover:bg-white/30"
        >
          <Pause size={14} /> Stopp
        </button>
      </div>
    </div>
  );
}
